import { useSuspenseQuery } from '@tanstack/react-query';

import { companyClient } from '../client/companyClient';
import { cacheKeys } from '../config';


export type Params = {
  id: number | string;
};

type Options = {
  enabled: boolean
  retry: boolean
};

const defaultOptions: Partial<Options> = {
  retry: false,
};

export const useCompany = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data: company } = {}, status, error } = useSuspenseQuery({
    queryKey: [cacheKeys.getCompany, params],
    queryFn: () => companyClient.getCompany(params),
    retry: options.retry,
  });

  return {
    status,
    error,
    company,
  };
};
